import { Controller } from "@hotwired/stimulus"
import { useDebounce } from "stimulus-use"

// Connects to data-controller="recurring-schedule--pair"
export default class extends Controller {
  static debounces = ["onInput"]
  static values = { pairId: Number, url: String, timeZone: String }
  static targets = ["day", "time", "output", "loading"]

  initialize() {
    this.first = true
  }

  connect() {
    useDebounce(this)

  }

  async onInput() {
    if (!this.valid()) return

    this.outputTarget.classList.add("hidden")
    this.loadingTarget.classList.remove("hidden")

    const token = document.querySelector('meta[name="csrf-token"]').content

    const day = this.dayTarget.value
    const time = this.timeTarget.value
    const timeZone = this.timeZoneValue

    const url = this.urlValue + "?" + new URLSearchParams({ pair_id: this.pairIdValue, day, time, time_zone: timeZone })

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "X-CSRF-Token": token,
        "Content-Type": "application/json"
      },
    })

    const t = await response.text()
    if (response.status != 200) {
      this.loadingTarget.classList.add("hidden")
      this.outputTarget.classList.remove("hidden")
      return
    }

    this.outputTarget.innerText = t

    this.loadingTarget.classList.add("hidden")
    this.outputTarget.classList.remove("hidden")
  }

  valid() {
    return this.dayTarget.checkValidity() &&
      this.timeTarget.checkValidity() &&
      this.timeTarget.value != "" &&
      this.timeZoneValue != ""
  }

  timeZoneValueChanged() {
    if (this.first) {
      this.first = false
      return
    }

    this.onInput()
  }
}
